module.exports = __webpack_public_path__ + "static/img/ss.7a6693c8.png";